// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2b2fbd98" + "." + "3779417db86fe73a" + ".js";
};